import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import KeenSlider, { KeenSliderInstance } from "keen-slider"
import { filter, Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ThemeService } from 'src/app/services/theme.service';


const animation = { duration: 25000, easing: (t) => t }
@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
})
export class AuthLayoutComponent implements OnInit {
  @ViewChild("sliderRef") sliderRef: ElementRef<HTMLElement>

  currentSlide: number = 0
  dotHelper: Array<Number> = []
  slider: any;
  isInIframe: boolean;
  private planSub!: Subscription;
  selectedPlan:any = null;
  isAuthRoute:boolean = false;
  private routeSub: Subscription;
  private authPaths = ['login', 'forgot', 'resetpassword', 'otp', 'newpass'];

  ngAfterViewInit() {
    setTimeout(() => {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        loop: true,
        defaultAnimation: {
          duration: 4000,
        },
        initial: this.currentSlide,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel
        },
    

      }, [
        (slider) => {
          let timeout
          let mouseOver = false
          function clearNextTimeout() {
            clearTimeout(timeout)
          }
          function nextTimeout() {
            clearTimeout(timeout)
            if (mouseOver) return
            timeout = setTimeout(() => {
              slider.next()
            }, 4000)
          }
          slider.on("created", () => {
            slider.container.addEventListener("mouseover", () => {
              mouseOver = true
              clearNextTimeout()
            })
            slider.container.addEventListener("mouseout", () => {
              mouseOver = false
              nextTimeout()
            })
            nextTimeout()
          })
          slider.on("dragStarted", clearNextTimeout)
          slider.on("animationEnded", nextTimeout)
          slider.on("updated", nextTimeout)
        },
      ])
      this.dotHelper = [
        ...Array(this.slider.track.details.slides.length).keys(),
      ]
    })
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy()
      this.planSub.unsubscribe();
     if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
  constructor(
    private themeService: ThemeService,
    private authService : AuthService,
    private router: Router
  ) { 
    this.isInIframe = this.themeService.isInIframe();
  }

  ngOnInit() {
    this.checkAuthRoute(this.router.url);
     this.routeSub = this.router.events
     .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event) => {
    const navEndEvent = event as NavigationEnd;
    this.checkAuthRoute(navEndEvent.urlAfterRedirects);
  });

    this.selectedPlan =  this.authService.getCookie('plan');
      this.planSub = this.authService.plan$.subscribe(plan => {
      this.selectedPlan = plan;
    });
  }
  private checkAuthRoute(url: string): void {
    this.isAuthRoute = this.authPaths.some(path => url.includes(path));
  }
  private getCookie(name: string): string | null {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
}
